const toggle = () => {
  const filter = document.querySelector('.c-filterbar__nav');
  const filterItems = document.querySelectorAll('.c-filterbar__item__name');
  const windowSize = window.innerWidth;

  if (filterItems.length) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < filterItems.length; i++) {
      filterItems[i].addEventListener('click', () => {
        if (windowSize <= 991) {
          if (
            filterItems[i].parentElement.classList.contains(
              'c-filterbar__item--close',
            ) ||
            filterItems[i].parentElement.classList.contains(
              'c-filterbar__item--open',
            )
          ) {
            filter.classList.toggle('c-filterbar__nav--expanded');
          } else {
            filterItems[i].parentElement.classList.toggle(
              'c-filterbar__item--expanded',
            );
          }
        } else {
          filter.classList.toggle('c-filterbar__nav--expanded');
        }
      });
    }
  }
};

export default { toggle };



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/filter.js